import {QUICK_BOOKS} from '../../../../common/constants/Integrations.js'
import QuickBooks from './QuickBooks.js'

export default {
  [QUICK_BOOKS]: QuickBooks,
}
